/* src/app/vehicle-inspections/pages/inspection-calendar/inspection-calendar.component.scss */
.calendarCard {
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  padding: 1rem;
}
.calendarToolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.calendarToolbar h3 {
  margin: 0;
}
.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.4rem 1rem;
  font-size: 0.8rem;
  color: #64748b;
}
.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.swatch {
  display: inline-block;
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 3px;
}
.swatch.overdue {
  background: #d9534f;
}
:host ::ng-deep .inspectionOverdue .cal-event-title {
  font-weight: 700;
}
:host ::ng-deep .cal-month-view .cal-event-title,
:host ::ng-deep .cal-week-view .cal-event-title {
  cursor: pointer;
}
.inspectionCell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px;
  min-height: 6rem;
  height: 100%;
}
.inspectionCell.otherMonth {
  opacity: 0.45;
}
.dayNumber {
  align-self: flex-end;
  font-size: 0.85rem;
  color: #64748b;
  margin-bottom: 2px;
}
.dayNumber.today {
  color: #fff;
  background: #f99420;
  border-radius: 999px;
  padding: 0 0.45rem;
}
.inspectionChip {
  font-size: 0.72rem;
  line-height: 1.25;
  padding: 2px 5px;
  border-left: 4px solid #0275d8;
  border-radius: 4px;
  background: #f1f5f9;
  color: #1e293b;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inspectionChip .chipType {
  color: #64748b;
}
.inspectionChip:hover {
  background: #e2e8f0;
}
.inspectionChip {
}
.inspectionChip.overdue {
  background: #d9534f;
  border-left-color: #a52a2a !important;
  color: #fff;
  font-weight: 600;
}
.inspectionChip.overdue .chipType {
  color: #fde8e8;
}
:host ::ng-deep .cal-week-view .cal-time-events {
  display: none;
}
:host ::ng-deep .cal-month-view .cal-cell-top {
  display: none;
}
:host ::ng-deep .cal-month-view .cal-day-cell {
  min-width: 0;
  overflow: hidden;
}
/*# sourceMappingURL=inspection-calendar.component.css.map */
